import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  makeStyles,
  Typography
} from '@material-ui/core';
import { toNaira } from 'src/utils/helper';
import formatPrice from 'src/utils/formatPrice';

const useStyles = makeStyles({
  root: {
    minWidth: 275
  },
  title: {
    fontSize: 20
  },
  balance: {
    fontSize: 30
  }
});

const BalanceCard = ({ balance }) => {
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography
            className={classes.balance}
            color="textSecondary"
            gutterBottom
          >
           {formatPrice(balance, 'NGN', toNaira)}
          </Typography>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Wallet Balance
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

BalanceCard.propTypes = {
    balance: PropTypes.string.isRequired
};

export default BalanceCard;
